module.exports = __webpack_public_path__ + "static/media/1009888.1dd40108.jpg";